import { atom, useAtom } from "jotai";

export const isMaintenanceAlertDismissedAtom = atom(false);

export const useIsMaintenanceAlertDismissed = () => {
  const [isMaintenanceAlertDismissed, setIsMaintenanceAlertDismissed] = useAtom(
    isMaintenanceAlertDismissedAtom,
  );

  return {
    isMaintenanceAlertDismissed,
    setIsMaintenanceAlertDismissed,
  };
};
